import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

/**
 *  KARBANTARTÁS ALATT NE DOLGOZZON TOVÁBB A FELÜLET.
 *
 *  Frissítés közben a kiszolgáló újraindul. A böngészőben nyitva maradt oldal ilyenkor
 *  fél-működő állapotba kerül: a kérések elszállnak, a mentés elveszik, a felhasználó
 *  pedig nem érti, mi történik — legfeljebb annyit lát, hogy „valami nem megy”.
 *
 *  A kiszolgáló ezért 503-at ad egy jelöléssel (`karbantartas: true`). Ha ilyet
 *  kapunk, egyetlen dolgot teszünk: átvisszük a felhasználót a várakozó oldalra, ami
 *  magától visszaenged, amint vége. Az eredeti címet megjegyezzük, hogy oda térjen
 *  vissza, ahol abbahagyta.
 */
@Injectable()
export class KarbantartasInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(catchError((hiba: HttpErrorResponse) => {
      if (hiba?.status === 503 && hiba?.error?.karbantartas) {
        const most = this.router.url || '/';
        if (!most.startsWith('/frissites-folyamatban')) {
          try { sessionStorage.setItem('karbantartas-vissza', most); } catch (e) { /* ignore */ }
          this.router.navigateByUrl('/frissites-folyamatban');
        }
      }
      return throwError(() => hiba);
    }));
  }
}
